<template>
  <div class="ifilawtj">
    <div class="tit2">合肥民商法类律师推荐</div>
    <div class="lawlist between wrap">
      <!-- <tilawrecitem
            class="lawitem"
            v-for="item in 4"
            :key="item"
            :isdef="item % 2 == 1"
          > -->
      <div class="lawitem" v-for="item in 4" :key="item">
        <div class="tilawrecitem" v-if="item % 2 == 1">
          <div class="cover">
            <img src="../../../assets/tiaolidetail/aaa.sample.png" alt="" />
          </div>
          <div class="baseinfo">
            <div class="ti">王XX <span>主办律师</span></div>
            <div class="des">
              {{
                `安徽大学本科毕业，业务精湛，具有深厚的法学理论知识、丰富的司法实践经验`
                  | toEllipsisFilter(33)
              }}
            </div>
            <div class="lxfs">
              <div class="rz">
                <svg-icon icon-class="dianhua" /> 188 9555 555
              </div>
              <div class="zx">在线咨询</div>
            </div>
          </div>
        </div>
        <div class="tilawrecitem" v-else>
          <div class="cover">
            <img src="../../../assets/tiaolidetail/default_sample.png" alt="" />
          </div>
          <div class="baseinfo">
            <div class="ti">律师入驻 <span>律观网</span></div>
            <div class="des">
              律观网，16年品牌，国内放心的互联网法律服务平台
            </div>
            <div class="lxfs">
              <div class="rz">入驻热线：400-000-0000</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ifilawtj {
  width: 856px;
  padding: 21px 27px 30px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  .tit2 {
    font-size: 24px;
    color: #333333;
  }
  .lawlist {
    padding-left: 50px;
    .lawitem {
      margin-top: 30px;
      width: 330px;
      height: 130px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      position: relative;
      padding: 16px 12px 16px 51px;
      .cover {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -48px;
        img {
          width: 84px;
          height: 84px;
          border-radius: 50%;
        }
      }
      .baseinfo {
        font-size: 14px;
        color: #999999;
        .ti {
          font-size: 18px;
          color: #333333;
          line-height: 18px;
          span {
            font-size: 14px;
            color: #666666;
            line-height: 14px;
            margin-left: 14px;
          }
        }
        .des {
          margin-top: 8px;
          line-height: 22px;
        }
        .lxfs {
          line-height: 26px;
          margin-top: 4px;
          .rz {
            float: left;
          }
          .zx {
            display: none;
            cursor: pointer;
            color: #fefefe;
            width: 80px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            background: #f25618;
            border-radius: 13px;
            float: right;
          }
        }
      }
      &:hover {
        .baseinfo .lxfs .zx {
          display: block;
        }
      }
    }
  }
}
</style>